<template>
  <ckeditor
    v-bind="$attrs"
    :value="value"
    @input="onInput"
    v-on="$listeners"
    :editor="editor"
    :config="editorConfig"
  ></ckeditor>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadAdapter from "@/components/elements/ckeditor/adapters/UploadAdapter";
export default {
  props: {
    value: {
      type: [String, Number, Array]
    }
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the editor.
        extraPlugins: [this.UploadAdapterPlugin]
      }
    };
  },
  methods: {
    onInput(evt) {
      this.$emit("input", evt);
    },
    UploadAdapterPlugin(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new UploadAdapter(loader);
      };
    }
  },
  created() {}
};
</script>
